const createAccountCheckbox = document.getElementById('createaccount');

if (createAccountCheckbox) {
    createAccountCheckbox.checked = true;

    const parent = createAccountCheckbox.closest('.woocommerce-account-fields');

    parent.classList.add('hide');
}